
import { defineComponent, computed, PropType } from 'vue'

// Components
import FormattedPrice from '@/components/FormattedPrice.vue'
import CountButton from '@/components/CountButton.vue'

// Types
import { LocalEventTicket } from '@/types/entitiesTypes'

// Utils
import { isNumber } from 'lodash'

export default defineComponent({
	name: 'EventTiers',
	emits: ['local-tickets-types-changed'],
	components: { CountButton, FormattedPrice },

	props: {
		eventTiers: {
			type: Array as PropType<LocalEventTicket[]>,
			default: () => []
		},

		allTicketsBought: {
			type: Boolean,
			default: false
		},

		purchaseLimitRemaining: {
			type: Number,
			default: null
		},

		ticketsInOrder: {
			type: Number,
			default: 0
		},

		countersHidden: {
			type: Boolean,
			default: false
		}
	},

	setup(props, { emit }) {
		// Computed
		const isOverLimit = computed(
			() =>
				isNumber(props.purchaseLimitRemaining) &&
				props.ticketsInOrder >= props.purchaseLimitRemaining
		)

		// Methods
		const updateEventTiers = (
			index: number,
			action: 'decrease' | 'increase'
		): void => {
			const updatedEventTiers = [...props.eventTiers]
			const eventTier = updatedEventTiers[index]

			if (eventTier?.quantity || eventTier?.quantity === 0) {
				if (action === 'decrease') {
					updatedEventTiers[index] = {
						...eventTier,
						quantity:
							eventTier.quantity === 0
								? eventTier.quantity
								: eventTier.quantity - 1
					}
				} else {
					updatedEventTiers[index] = {
						...eventTier,
						quantity: eventTier.quantity + 1
					}
				}

				emit('local-tickets-types-changed', updatedEventTiers)
			}
		}
		const decrease = (index: number): void => {
			updateEventTiers(index, 'decrease')
		}

		const increase = (index: number): void => {
			updateEventTiers(index, 'increase')
		}

		return {
			decrease,
			increase,
			isOverLimit
		}
	}
})
